var Team = (function($) {
  function initTeamInteraction() {
    const $items = $(".team-item");

    // Click → activar
    $items.on("click", function() {
      const $clicked = $(this);

      // cerrar otros
      $items.not($clicked).removeClass("team-item--active");

      // toggle en el clicado
      $clicked.toggleClass("team-item--active");
    });

    // Mouse leave → volver a estado normal
    $items.on("mouseleave", function() {
      $(this).removeClass("team-item--active");
    });
  }

  function init() {
    if (!$(".team").length) return;
    initTeamInteraction();
  }

  return { init };
})(jQuery);

jQuery(document).ready(Team.init);
